export default "__VITE_ASSET__ZIEJI3or__"